/**
 * Storage Service
 * Handles low-level database initialization
 * NOTE: Most logic has been moved to services/boardService.ts and services/authService.ts
 */

// Initialize the database (No-op for Supabase, kept for API compatibility)
export const initDB = async (): Promise<void> => {
    // Check connection?
    return Promise.resolve(null);
};

// Re-export specific legacy functions if needed for temporary compatibility
// But generally, consumers should migrate to services.

/**
 * Safe Storage Helpers
 */

const createSafeStorage = (storageType: 'localStorage' | 'sessionStorage') => {
    const getStorage = () => {
        try {
            return typeof window !== 'undefined' ? window[storageType] : null;
        } catch {
            return null;
        }
    };

    return {
        getItem: (key: string): string | null => {
            try { return getStorage()?.getItem(key) || null; } catch { return null; }
        },
        setItem: (key: string, value: string): boolean => {
            try { getStorage()?.setItem(key, value); return true; } catch { return false; }
        },
        removeItem: (key: string): void => {
            try { getStorage()?.removeItem(key); } catch { /* ignore */ }
        },
        clear: (): void => {
            try { getStorage()?.clear(); } catch { /* ignore */ }
        }
    };
};

export const safeLocalStorage = createSafeStorage('localStorage');
export const safeSessionStorage = createSafeStorage('sessionStorage');
